import PipManager from '../../device-api/pip-manager';
import { isMac } from '../device-identifier';
const MAC_KEYS = ['Meta', 'Alt', 'Shift', '’'];
const WIN_KEYS = ['Ctrl', 'Shift', '}'];
const BLOCK_CHECKER_MAP = {
    Mac: (keysDown, event) => {
        return MAC_KEYS.every((key) => keysDown.has(key)) || (event.key === '’' && event.metaKey && event.altKey && event.shiftKey);
    },
    Windows: (keysDown, event) => {
        return WIN_KEYS.every((key) => keysDown.has(key)) || (event.key === '}' && event.ctrlKey && event.shiftKey);
    },
};
/* @jscrambler enable stringConcealing */
export class FirefoxPipManager extends PipManager {
    keysDown = new Set();
    blockChecker;
    isPipEnabled = true;
    constructor() {
        super();
        this.blockChecker = isMac() ? BLOCK_CHECKER_MAP.Mac : BLOCK_CHECKER_MAP.Windows;
    }
    disablePip(videoElement) {
        if (this.isPipEnabled) {
            this.addEventListeners();
        }
        videoElement.disablePictureInPicture = true;
        this.isPipEnabled = false;
        this.keysDown.clear();
    }
    enablePip(videoElement) {
        videoElement.disablePictureInPicture = false;
        this.isPipEnabled = true;
        this.removeEventListeners();
        this.keysDown.clear();
    }
    addEventListeners() {
        self.addEventListener('keydown', this.logKeyDown);
        self.addEventListener('keyup', this.logKeyUp);
    }
    logKeyDown = (event) => {
        this.keysDown.add(event.key);
        if (this.shouldPreventShortcutEvent(event)) {
            event.preventDefault();
        }
    };
    shouldPreventShortcutEvent(event) {
        return this.blockChecker(this.keysDown, event);
    }
    logKeyUp = (event) => {
        this.keysDown.delete(event.key);
    };
    removeEventListeners() {
        self.removeEventListener('keydown', this.logKeyDown);
        self.removeEventListener('keyup', this.logKeyUp);
    }
}
//# sourceMappingURL=firefox-pip-manager.js.map